import {insertScript} from '@optimaxdev/utils';

import {FUNCTIONAL_COOKIES} from 'constants/analytics';
import {INSTANT_FEEDBACK_WIDGET_ID, REVIEWS_POPUPS_SRC} from 'constants/popupNames';
import {waitForActivatingCookieGroup} from 'features/oneTrust/oneTrust';
import {ReviewPopupsType} from 'types/reviewPopupsTypes';

let data: ReviewPopupsType;

/**
 * callback when site jabber script will be included
 */
function siteJabberCallBack(setIsPopupLoading?: (isLoading: boolean) => void) {
    return () => {
        if (setIsPopupLoading) setIsPopupLoading(false);

        const {id, shipping_address: shippingAddress} = data;
        // @ts-expect-error
        const popup = new STJR.InstantFeedbackWidget({
            id: INSTANT_FEEDBACK_WIDGET_ID,
            language: 'en',
            order_id: id,
            url: 'glassesusa.com',
            user: {
                email: shippingAddress.email,
                first_name: shippingAddress.firstname,
                last_name: shippingAddress.lastname,
            },
        });
        popup.render();

        const closeClickCallback = (e: MouseEvent) => {
            window.dispatchEvent(new CustomEvent('upsell:popupClose'));
            popup.closeClick(e);
        };

        let btn: HTMLAnchorElement | null = null;
        const interval = setInterval(() => {
            if (btn) {
                clearInterval(interval);
                btn.addEventListener('click', closeClickCallback);
            }
            btn = document.querySelector(`.stjr-review-checkout-widget-body__close`);
        }, 200);
    };
}

/**
 * SiteJabber initialization at TYP
 */
export async function initSiteJabber(
    orderDetails: ReviewPopupsType,
    setIsPopupLoading?: (isLoading: boolean) => void,
) {
    await waitForActivatingCookieGroup(FUNCTIONAL_COOKIES);
    data = orderDetails;
    if (setIsPopupLoading) setIsPopupLoading(true);
    insertScript(REVIEWS_POPUPS_SRC.SITEJABBER, true, siteJabberCallBack(setIsPopupLoading));
}
